import React, { useEffect, useState } from 'react';
import i18next from 'i18next';
import { getOperatore, getCurrentUsername } from '../../utils/currentUser';
import './FasciaOperatore.css';

/**
 * LA FASCIA ARANCIONE dell'Accesso al sito (4 novembre 2026).
 *
 * Quando un operatore del backoffice e' sul sito con il conto di un giocatore,
 * il gettone lo dice (claim «operatore») e questa fascia sta in cima a ogni
 * pagina, non si chiude e dice tre cose: di chi e' il conto, chi e' al
 * computer, quanto manca alla fine. «Esci» chiude SOLO questa sessione da
 * operatore: il giocatore resta collegato dove era.
 *
 * Il tempo che resta e' quello che il server ha dato all'accesso
 * (sessione.durata_massima_fino_a, qui mezz'ora): allo scadere il custode
 * (services/sessione.js) chiude la sessione con «La sessione da operatore e'
 * finita». Qui si legge solo l'orologio, una volta al secondo.
 *
 * Con la testata Nova, che e' fissa in alto, la fascia e' fissa anch'essa e
 * la testata scende di quanto e' alta (html.con-operatore in FasciaOperatore.css).
 */
const CHIAVE_FINE = 'sessione.durata_massima_fino_a';

/** «28:41» da un istante futuro; «0:00» quando e' passato. */
export function tempoRimasto(fino, adesso = Date.now()) {
  const secondi = Math.max(0, Math.floor((Number(fino) - adesso) / 1000));
  const m = Math.floor(secondi / 60);
  const s = secondi % 60;
  return `${m}:${s < 10 ? '0' : ''}${s}`;
}

function leggi() {
  let fino = 0;
  try { fino = Number(window.localStorage.getItem(CHIAVE_FINE)) || 0; } catch (e) { fino = 0; }
  return { operatore: getOperatore(), conto: getCurrentUsername() || '', fino };
}

export default function FasciaOperatore({ userService, fissa = false }) {
  const [stato, setStato] = useState(leggi);
  const [uscito, setUscito] = useState(false);
  const presente = !!stato.operatore;

  useEffect(() => {
    const orologio = window.setInterval(() => setStato(leggi()), 1000);
    return () => window.clearInterval(orologio);
  }, []);

  useEffect(() => {
    const radice = document.documentElement;
    if (presente || uscito) radice.classList.add('con-operatore'); else radice.classList.remove('con-operatore');
    return () => radice.classList.remove('con-operatore');
  }, [presente, uscito]);

  if (uscito) {
    return (
      <div role="status" className={`fascia-operatore uscito${fissa ? ' fissa' : ''}`}>
        <span className="fascia-operatore-testo">{i18next.t('Sei uscito dal conto del giocatore. Puoi chiudere questa scheda e tornare al backoffice.')}</span>
      </div>
    );
  }
  if (!presente) return null;

  const esci = () => {
    if (userService && typeof userService.doLogout === 'function') userService.doLogout();
    setUscito(true);
    // la scheda l'ha aperta il backoffice: se il browser lo permette si chiude da sola
    window.setTimeout(() => { try { window.close(); } catch (e) { /* resta la fascia grigia */ } }, 150);
  };

  const chi = stato.operatore.username || stato.operatore.id;
  return (
    <div role="status" className={`fascia-operatore${fissa ? ' fissa' : ''}`}>
      <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 4-6 8-6s8 2 8 6" />
      </svg>
      <span className="fascia-operatore-testo">
        <b>{i18next.t('Stai usando il conto di {{conto}}', { conto: stato.conto })}</b>
        {' '}{i18next.t('come operatore {{chi}}. Ogni azione resta nel Registro come fatta da te.', { chi })}
      </span>
      {stato.fino > 0 && (
        <span className="fascia-operatore-tempo" title={i18next.t('quanto manca alla fine della sessione da operatore')}>
          {i18next.t('{{tempo}} rimasti', { tempo: tempoRimasto(stato.fino) })}
        </span>
      )}
      <button type="button" className="fascia-operatore-esci" onClick={esci}>{i18next.t('Esci')}</button>
    </div>
  );
}
